import React from "react";
import { ArrayInput, BooleanInput, SelectInput, SimpleFormIterator, TextInput } from "react-admin";
import { useFormContext } from "react-hook-form";

// Types
import { CreateOrganizationProps } from "../../types/organizations";
import { Role } from "../../types/role.enum";

// Hooks
import useValidators from "../../hooks/useValidators";

// Components
import AddMember from "./AddMember";
import DeleteMember from "./DeleteMember";

type CreateOrganizationFormProps = {
  formData: CreateOrganizationProps;
};

export const CreateOrganizationForm: React.FC<CreateOrganizationFormProps> = ({ formData }) => {
  const formContext = useFormContext();
  const { text, role } = useValidators();

  const roles: { id: Role; name: Role }[] = [
    { id: Role.OPERATOR, name: Role.OPERATOR },
    { id: Role.OWNER, name: Role.OWNER },
    { id: Role.SUPERVISOR, name: Role.SUPERVISOR },
    { id: Role.CUSTOMER, name: Role.CUSTOMER },
  ];

  const addUser = (index: number) => {
    const users = formContext.getValues("users");
    const members = formContext.getValues("members");
    const newListMembers = [...members, users[index]];
    users.splice(index, 1);
    formContext.setValue("members", newListMembers);
    formContext.setValue("users", users);
  };

  const deleteMember = (index: number) => {
    const users = formContext.getValues("users");
    const members = formContext.getValues("members");
    const newListUsers = [...users, { ...members[index], role: "" }];
    members.splice(index, 1);
    formContext.setValue("members", members);
    formContext.setValue("users", newListUsers);
  };

  return (
    <>
      <TextInput
        label="Title"
        source="name"
        defaultValue="1"
        onChange={(event) => formContext.setValue("name", event.target.value)}
        validate={text}
      />
      <BooleanInput value={formData.active} label="Active" source="active" />
      <BooleanInput value={formData.isTecheat} label="Is Techeat" source="isTecheat" />
      <ArrayInput source="members">
        <SimpleFormIterator
          removeButton={<DeleteMember onClick={deleteMember} />}
          disableAdd
          disableReordering
          disableClear
          inline
        >
          <TextInput readOnly source="email" helperText={false} />
          <SelectInput source="role" emptyText="No organization selected" choices={roles} validate={role} />
        </SimpleFormIterator>
      </ArrayInput>
      <ArrayInput source="users">
        <SimpleFormIterator
          disableClear
          disableAdd
          disableReordering
          removeButton={<AddMember onClick={addUser} />}
          inline
        >
          <TextInput readOnly source="email" helperText={false} />
        </SimpleFormIterator>
      </ArrayInput>
    </>
  );
};
